import { chain, groupBy } from 'lodash';
import { orderbookMap2Array } from '@/utils/grouping';

type Side = 'Sell' | 'Buy';
interface Board {
  'id': number;
  'side': Side;
  'size': number;
  'price': number;
}
export interface Boards {
  'action': string;
  'data': Board[];
}

interface BidsAsks {
  bids: Map<string, Board>;
  asks: Map<string, Board>;
}

export class Orderbook {
  private bidsAsks = {
    bids: new Map(),
    asks: new Map(),
  } as BidsAsks;
  public _setData(data: Boards) {
    switch (data.action) {
      case 'delete':
        this._delete(data.data);
        break;
      case 'insert':
        this._insert(data.data);
        break;
      case 'partial':
        this._partial(data.data);
        break;
      case 'update':
        this._update(data.data);
        break;
      default:
        break;
    }
  }
  public getOrderbook() {
    return orderbookMap2Array(this.bidsAsks);
  }
  private _partial(data: Board[]) {
    const groupBySide = groupBy(data, 'side');
    Object.keys(this.bidsAsks).forEach((kind) => {
      this.bidsAsks[kind as keyof BidsAsks].clear();
      const side = (kind === 'bids') ? 'Buy' : 'Sell';
      this.bidsAsks[kind as keyof BidsAsks] = new Map(
        chain(groupBySide[side])
          .keyBy('id')
          .toPairs()
          .map((value) => {
            const board = Object.assign({}, value[1]);
            board.size = value[1].size / value[1].price;
            return [value[0], board] as [string, Board];
          })
          .value(),
      );
    });
  }
  private _delete(data: Board[]) {
    data.forEach((board) => {
      const kind = (board.side === 'Buy') ? 'bids' : 'asks';
      this.bidsAsks[kind].delete(board.id + '');
    });
  }
  private _update(data: Board[]) {
    data.forEach((board) => {
      const kind = (board.side === 'Buy') ? 'bids' : 'asks';
      const entry = this.bidsAsks[kind].get(board.id + '');
      if (!entry) {
          return;
      }
      board.size = board.size / entry.price;
      const updateEntry = Object.assign({ ...entry }, board);
      this.bidsAsks[kind].set(board.id + '', updateEntry);
    });
  }
  private _insert(data: Board[]) {
    data.forEach((board) => {
      board.size = board.size / board.price;
      const kind = (board.side === 'Buy') ? 'bids' : 'asks';
      this.bidsAsks[kind].set(board.id + '', board);
    });
  }
}
